module.exports = __webpack_public_path__ + "static/img/logo.acc184ea.png";